import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import CountUp from "react-countup";
// import carImageUrl from "./images/car-image.webp";
import ArrowIcon from "../arrow/index";

const PostBcMyBookingCarCard = ({
    handleOpenPriceBreakDownModal = () => {},
    carAmountLabel,
    totalLoanAmount,
    isFinanceUser,
    emi,
    frequency,
    showNumberAnimation,
    carImageUrl,
    orderId
}) => {

    return (
        <React.Fragment>
            <div styleName={"styles.leftWrapper"}>
                <p styleName={"styles.loanAmount"} onClick={handleOpenPriceBreakDownModal}>
                    {carAmountLabel} <ArrowIcon DarkGrey rotateBy={180}/>
                </p>

                <p styleName={"styles.totalAmount"}>
                    {showNumberAnimation ? (
                        <CountUp duration={1} separator="," prefix="$" end={totalLoanAmount} />
                    ) : (
                        <span>
                            {makePriceLabelRound(totalLoanAmount)}
                        </span>
                    )}&nbsp;
                    {isFinanceUser && "|"}&nbsp;
                    {isFinanceUser && (
                        <React.Fragment>
                            {showNumberAnimation ? (
                                <p styleName={"styles.loanEmi"}>
                                    <CountUp duration={1} separator="," prefix="$" end={emi} />/{ frequency }
                                </p>
                            ) : (
                                <React.Fragment>
                                    {makePriceLabelRound(emi)}/{frequency}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </p>
            </div>
            <div styleName={"styles.imageWrapper"}>
                <img src={carImageUrl} />
                <p styleName={"styles.reserved"}>
                    Order ID : {orderId}
                </p>
            </div>
        </React.Fragment>
    );
};

PostBcMyBookingCarCard.propTypes = {
    handleOpenPriceBreakDownModal: PropTypes.func,
    carAmountLabel: PropTypes.string,
    totalLoanAmount: PropTypes.number,
    isFinanceUser: PropTypes.bool,
    emi: PropTypes.number,
    frequency: PropTypes.string,
    showNumberAnimation: PropTypes.bool,
    carImageUrl: PropTypes.string,
    orderId: PropTypes.string
};

export default PostBcMyBookingCarCard;
